<template>
  <m-pageframe title="{organization-label}: Create Guest Check In Form">
    <v-container fluid class="px-md-8">
      <v-row justify="space-between" align="center" class="my-2" dense>
        <v-col cols="auto">
          <link-back text="Cancel" :fallback_route="back_route" />
        </v-col>

        <v-col cols="auto" class="d-flex align-center">
          <validation-issues-button
            :issues="validation_warnings"
            title="Issues Preventing Creation"
            :tooltip_text="tooltip_text"
            class="mr-3"
            @fix-issue="handleFixWarning"
          />
          <v-btn
            color="primary"
            :disabled="!is_form_valid"
            @click="handleCreateForm"
          >
            Create Guest Check-In Form
          </v-btn>
        </v-col>
      </v-row>

      <guest-check-in-template-creator
        ref="templateCreator"
        class="mb-10"
        :organization_id="$route.params.organization_id"
        @form-created="sendToEditPage"
        @cancel="$router.push(back_route)"
        @form-valid-changed="onFormValidChanged"
        @validation-warnings-changed="onValidationWarningsChanged"
      />
    </v-container>
  </m-pageframe>
</template>

<script>
import GuestCheckInTemplateCreator from '../../components/guest-check-in/guest-check-in-template-creator.vue';
import ValidationIssuesButton from '../../components/shared/validation/validation-issues-button.vue';

export default {
  name: 'GuestCheckInTemplateSelection',

  components: {
    GuestCheckInTemplateCreator,
    ValidationIssuesButton,
  },

  data() {
    return {
      is_form_valid: false,
      validation_warnings: [],
    };
  },

  computed: {
    back_route() {
      return {
        name: 'search-forms-guest-check-in',
        params: { organization_id: this.$route.params.organization_id },
      };
    },

    tooltip_text() {
      if (!this.validation_warnings?.length) return '';
      return `${this.validation_warnings.length} issue${this.validation_warnings.length !== 1 ? 's' : ''} preventing creation`;
    }
  },

  methods: {
    handleCreateForm() {
      if (this.$refs.templateCreator) {
        this.$refs.templateCreator.createForm();
      }
    },
    onFormValidChanged(isValid) {
      this.is_form_valid = isValid;
    },
    onValidationWarningsChanged(warnings) {
      this.validation_warnings = warnings;
    },
    handleFixWarning(warning) {
      if (this.$refs.templateCreator) {
        this.$refs.templateCreator.fixWarning(warning);
      }
    },
    sendToEditPage(guest_check_in_form_id) {
      this.$router.push({
        name: 'guest-check-in-edit',
        params: { organization_id: this.$route.params.organization_id, guest_check_in_form_id },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  max-width: 1920px;
}
</style>
